"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeBoxNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_CARDS_VENTA_CRUZADA
 * @param {object} fields
 * @returns
 */
const safeBoxNormalizer = (data) => {
    var _a, _b, _c, _d;
    try {
        let res = null;
        const title = ((_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title) || ((_c = (_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.fields) === null || _c === void 0 ? void 0 : _c.title);
        const listadoCards = (_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.COMPONET_CARD_SERVICIOS;
        if (listadoCards && Array.isArray(listadoCards) && listadoCards.length > 0) {
            const normalizedInfo = {};
            if (title) {
                normalizedInfo["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
            }
            listadoCards.map((carac, index) => {
                const { fields } = carac;
                const { title, description, href, crossedPrice, labelCard, postPrice: priceText, prePrice, price, promoLabel, underPrice, unityPrice, target } = fields;
                const card = {};
                if (href) {
                    card["CustomLink-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["CustomLink-1"]), { href: href, title: title || '' });
                    if (!!target) {
                        card["CustomLink-1"].target = target;
                    }
                }
                if (title) {
                    card["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-1"]), { text: title });
                }
                if (description) {
                    card["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-2"]), { text: description });
                }
                if (!!prePrice) {
                    card["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-3"]), { text: prePrice });
                }
                if (!!underPrice) {
                    card["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-4"]), { text: underPrice });
                }
                if (!!labelCard) {
                    card["Label-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Label-0"]), { text: labelCard });
                }
                if (!!promoLabel) {
                    card["Label-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Label-1"]), { label: promoLabel });
                }
                let currency = "";
                let quote = "";
                if (!!unityPrice) {
                    const currencySplit = unityPrice.split("/");
                    currency = currencySplit[0];
                    quote = currencySplit[1] || "";
                }
                let price1 = { currency };
                let price2 = { price: price, currency, quote };
                if (!!crossedPrice) {
                    if ((product === null || product === void 0 ? void 0 : product.price) !== crossedPrice) {
                        price1.price = crossedPrice;
                        price2 = Object.assign(Object.assign({}, price2), { price: price, color: "red_dark" });
                    }
                }
                else {
                    if (!price) {
                        price2 = {
                            price: null, currency: unityPrice,
                            quote: ""
                        };
                    }
                    if (!unityPrice) {
                        price2 = {
                            price: null, currency: '',
                            quote: ""
                        };
                    }
                }
                if (price1 && price1.price) {
                    card["Price-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Price-1"]), price1);
                }
                if (price2 && (price2.price || price2.currency)) {
                    card["Price-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Price-2"]), price2);
                }
                if (priceText) {
                    card["Price-Text"] = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Price-Text"]), { text: priceText });
                }
                const hasItems = Object.keys(card).length > 0;
                if (hasItems) {
                    normalizedInfo[`Charac-${index}`] = card;
                }
            });
            res = normalizedInfo;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.safeBoxNormalizer = safeBoxNormalizer;
exports.default = exports.safeBoxNormalizer;
//# sourceMappingURL=index.js.map